import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { CompositionTypeService } from '@services/composition-types/composition-type.service';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-composition-types',
    templateUrl: './composition-types.component.html',
    styleUrls: ['./composition-types.component.scss'],
    providers: [CompositionTypeService],
    standalone: false
})
export class CompositionTypesComponent implements OnInit, OnDestroy {

  public title = 'All Composition Types';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'title' }
  ];

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  constructor(
    public compositionTypeService: CompositionTypeService,
    private router: Router,
    private dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.createPageActions();
  }

  ngOnDestroy() {

  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['composition-types', event.row._id]);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService
      .confirm('Remove composition type?')
      .then(res => {
        if (!res) {
          return;
        }

        return this.compositionTypeService.remove(event.row._id).then(() => {
          this.dataTable.refresh();
        }).catch(error => {
          return this.dialogService.confirm(error.message, error.name);
        });
      });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'create_new_folder',
        title: 'Create New Type',
        callback: () => {
          this.router.navigate(['composition-types/create']);
        }
      }),
      new PageAction({
        icon: 'bathtub',
        title: 'CleanUp Quill',
        callback: () => {
          this.router.navigate(['composition-types/cleanUpQuill']);
        }
      })
    ];
  }

}
